import React, { useEffect, useState } from 'react';
import './upgradeMulticreatorsPane.module.scss';
import { V3Routes } from '../../../routes';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { SettingPane } from '../../molecules/mypage/page';
import MultiCreatorBannerPc from './images/multicreator_banner.png';
import { CheckBox } from '@sheinc/design-system';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import { BodyText } from '@sheinc/shelikes-design-system';

export const UpgradeMultiCreatorsPane = () => {
  const [checked, setChecked] = useState(false);

  // TODO: マルシーコースの申し込みページができたら修正
  const page_key = 'multicreator';
  const user = GlobalStatesV3.currentUser;

  useEffect(() => {
    if (user.isMultiCreatorUser()) {
      GlobalStatesV3.routing.push(V3Routes.home());
    }
  }, []);
  return (
    <SettingPane title="コースのアップグレード" activeMenu="multicreator">
      <a id="multicreator_lp_link" styleName="banner_wrapper" href="https://shelikes.jp/multicreator" target="_blank">
        <img styleName="banner" src={MultiCreatorBannerPc} />
      </a>

      <div styleName="description">
        <BodyText>
          1on1キャリアコーチングを元に、自分らしいキャリアの実現をサポートする、短期集中型の特別コースです。少人数のコミュニティで、仲間と切磋琢磨しながらキャリアチェンジを目指します。
        </BodyText>
      </div>
      <div styleName="actions">
        <CheckBox id="check-confirm" textSize="label" checked={checked} onCheck={() => setChecked(!checked)}>
          無料オンライン説明会を受けました
        </CheckBox>
        <div styleName="button_wrapper">
          <Button
            type="multicreator"
            size="m"
            id="multicreator_link"
            disabled={!checked}
            onClick={() => GlobalStatesV3.routing.push(V3Routes.applicationPageSignIn(page_key))}
          >
            <div styleName="button-text">入会する</div>
            <div styleName="arrow" />
          </Button>
        </div>
      </div>
    </SettingPane>
  );
};
